import * as React from 'react';
import * as ScrollAreaPrimitive from '@radix-ui/react-scroll-area';
import type { VariantProps } from 'class-variance-authority';
import { cva } from 'class-variance-authority';
import { cn } from '../../utils/cn';

export const _scrollBarVariant = cva(
    'flex touch-none select-none p-px transition-colors',
    {
        variants: {
            scrollBarVisibility: {
                visible: '',
                hidden: 'invisible',
            },
        },
        defaultVariants: {
            scrollBarVisibility: 'visible',
        },
    },
);

export const ScrollBar = React.forwardRef<
    React.ElementRef<typeof ScrollAreaPrimitive.ScrollAreaScrollbar>,
    React.ComponentPropsWithoutRef<
        typeof ScrollAreaPrimitive.ScrollAreaScrollbar
    > &
        VariantProps<typeof _scrollBarVariant> & {
            thumbClassName?: string;
        }
>(
    (
        {
            className,
            thumbClassName,
            orientation = 'vertical',
            scrollBarVisibility,
            ...props
        },
        ref,
    ) => (
        <ScrollAreaPrimitive.ScrollAreaScrollbar
            ref={ref}
            data-slot="scroll-area-scrollbar"
            orientation={orientation}
            className={cn(
                _scrollBarVariant({ scrollBarVisibility }),
                orientation === 'vertical' &&
                    'h-full w-2.5 border-l border-l-transparent',
                orientation === 'horizontal' &&
                    'h-2.5 flex-col border-t border-t-transparent',
                className,
            )}
            {...props}
        >
            <ScrollAreaPrimitive.ScrollAreaThumb
                data-slot="scroll-area-thumb"
                className={cn(
                    'relative flex-1 rounded-full bg-border',
                    thumbClassName,
                )}
            />
        </ScrollAreaPrimitive.ScrollAreaScrollbar>
    ),
);

ScrollBar.displayName = ScrollAreaPrimitive.ScrollAreaScrollbar.displayName;
